import api from '../../api/api.js'
import order from '../../api/moudles/order.js'
import { Message } from 'element-ui'

import {
	REMOVE_STATE_T,
	REMOVE_STATE_R,
	REMOVE_STATE_P


} from '../mutation-types'
import { error } from 'jquery'

const state = {
	orderNo: '',
	qrCode: '',
	qrCodePrice: '',
	T: null,
	R: null,
	num: 0,
	num01: 0,
	num02: 0,
	isChecked: false,
	payorderlist: [],
	payordercount: 0,
	actualIntegral: 0,
	expectIntegral: 0,
	usableIntegral: 0,
	pointsInfomation: []

}

const getters = {}

const actions = {
	//获取用户的积分
	getSellerPoint({ state }, payload) {
		order
			.getSellerPoint(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('用户积分', res.data)
					state.actualIntegral = res.data.actualIntegral
					state.expectIntegral = res.data.expectIntegral
					state.usableIntegral = res.data.usableIntegral
				}
			})
	},
	//查询积分变更信息
	pointChange({ state }, payload) {
		order
			.pointChange(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('积分变更', res.data)
					state.pointsInfomation = res.data
				}
			})
	},
	//查询订单信息
	OrderTracking({ state }, payload) {
		order
			.OrderTracking(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('支付订单查询', res.datas)
					console.log(res.data.data)
					state.payorderlist = res.data.data
					state.payordercount = res.data.count
				}
			})
	},
	//创建支付宝订单
	createOrderalipay({ state, dispatch }, payload) {
		order
			.createOrderalipay(payload)
			.then(res => {
				console.log('支付宝二维码', res)
				let newfile = JSON.stringify(res)
				localStorage.removeItem('html')
				localStorage.setItem('alipay', newfile)
				let newUrl = location.host + '/sealpage'
				console.log(newUrl)

				if (newUrl.indexOf('shopsooo') > -1) {
					window.open('http://' + newUrl)
				} else {
					window.open('https://' + newUrl)
				}



				if (res.code === 200) {
					console.log('支付宝二维码', res.data)

				}
			})
	},
	//创建Payssion订单
	createPayorderByPayssion({ state, dispatch }, payload) {
		order
			.createPayorderByPayssion(payload)
			.then(res => {
				console.log('Payssion', res)
				if (res.code == 200) {
					state.orderNo = res.data.orderNo
					state.qrCode = res.data.qrCode
					state.qrCodePrice = res.data.camount
					window.open(res.data.qrCode)
					// if (state.orderNo) {
					// 	clearInterval(state.P)
					// 	state.P = setInterval(() => {
					// 		dispatch('checkPayOrderPayssion', { orderNo: res.data.orderNo })
					// 	}, 1000)
					// }
				} else if (res.code == 417) {
					Message({
						message: '当前充值金额过低，请重新充值！',
						type: 'warning'
					})
					state.qrCode = ''
				}else {
					Message({
						message: res.msg,
						type: 'warning'
					})
					state.qrCode = ''
				}


				if (res.code === 200) {
					console.log('Payssion', res.data)

				}
			})
	},
	//创建支付订单
	createPayorderBywechat({ state, dispatch }, payload) {
		order
			.createPayorderBywechat(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('微信二维码', res.data)
					state.orderNo = res.data.orderNo
					state.qrCode = res.data.qrCode
					state.T = setInterval(() => {
						dispatch('checkPayOrder', { orderNo: res.data.orderNo })
					}, 1000)
				}
			})
	},
	//轮询Payssion支付是否成功
	checkPayOrderPayssion({ state, dispatch }, payload) {
		order
			.checkPayOrderPayssion(payload)
			.then(res => {
				if (res.code === 200) {
					Message({
						message: '充值成功！',
						type: 'success'
					})
					clearInterval(state.P)
					setTimeout(() => {
						state.isChecked = true
					}, 1000)
					setTimeout(() => {
						state.isChecked = false
					}, 2000)
				}
			})
	},
	//轮询微信支付是否成功
	checkPayOrder({ state, dispatch }, payload) {
		order
			.checkPayOrder(payload)
			.then(res => {
				if (res.code === 200) {
					Message({
						message: '充值成功！',
						type: 'success'
					})
					clearInterval(state.T)
					setTimeout(() => {
						state.isChecked = true
					}, 1000)
					setTimeout(() => {
						state.isChecked = false
					}, 2000)
				}
			})
	},

	//轮询支付宝支付是否成功
	checkOrderalipay({ state, dispatch }, payload) {
		order
			.checkOrderalipay(payload)
			.then(res => {
				if (res.code === 200) {
					Message({
						message: '充值成功！',
						type: 'success'
					})
					clearInterval(state.R)
					setTimeout(() => {
						state.isChecked = true
					}, 1000)
					setTimeout(() => {
						state.isChecked = false
					}, 2000)

				}
			})
	},
}

const mutations = {
	[REMOVE_STATE_T]: (state) => {
		state.num = 1
		clearInterval(state.T)
	},

	[REMOVE_STATE_R]: (state) => {
		state.num01 = 1
		clearInterval(state.R)
	},

	[REMOVE_STATE_P]: (state) => {
		state.num02 = 1
		clearInterval(state.P)
	}

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}